// extracted by mini-css-extract-plugin
module.exports = {"main":"Partners_main__ItI1h","wrapper":"Partners_wrapper__L0BMH","button":"Partners_button__1bKeO","logo":"Partners_logo__pLkar","title":"Partners_title__fj_VT"};